import { normalizeDate, normalizedTimesByDate as buildNormalizedTimesByDate, slotsLabel } from './edit_form_time_section_utils';

/**
 * Update heading for available-slots mode: "Date (N slots available)" for the given day.
 */
export function updateAvailableHeadingMeta(section, headingTitle, dayKey) {
  if (!headingTitle) return;
  const toggle = section.querySelector(`.js-showing-view-time-day-toggle[data-day-key="${dayKey}"]`);
  const panel = section.querySelector(`.js-showing-view-time-day-panel[data-day-key="${dayKey}"]`);
  const dateLabel = toggle?.dataset?.dateLabel;
  const slotsCount = Number(panel?.dataset?.slotsCount || 0);
  const slotsText = slotsLabel(slotsCount);
  headingTitle.textContent = dateLabel ? `${dateLabel} (${slotsCount} ${slotsText} available)` : (headingTitle.dataset.defaultText || '');
}

/**
 * Update heading for lockbox mode: "Date (N slots available)" for the selected lockbox date.
 */
export function updateLockboxHeadingMeta(section, headingTitle, lockboxWrap, lockboxDateSelect) {
  if (!headingTitle || !lockboxWrap) return;
  if (!lockboxDateSelect) {
    headingTitle.textContent =
      lockboxWrap.querySelector('.showing-view-popup__muted')?.textContent?.trim() ||
      'No self-show times available.';
    return;
  }

  const timesByDateRaw = JSON.parse(lockboxWrap.dataset.timesByDate || '{}');
  const byDate = buildNormalizedTimesByDate(timesByDateRaw);

  const selectedDateKey = normalizeDate(lockboxDateSelect.value);
  if (!selectedDateKey) {
    headingTitle.textContent = headingTitle.dataset.defaultText || '';
    return;
  }

  const dateText = lockboxDateSelect.selectedOptions?.[0]?.text || selectedDateKey;
  const slotsCount = (byDate[selectedDateKey] || []).length;
  const slotsText = slotsLabel(slotsCount);
  headingTitle.textContent = `${dateText} (${slotsCount} ${slotsText} available)`;
}
